<template>
<div class="chapter">
<div class="inner_page">
<div>
<h1 class="center">Contents</h1>
<p class="center" style="margin-top:1em; margin-bottom:1em;"><img alt="" src="image/Image2.jpg"/></p>
<p class="toc2" style="margin-top:20px;"><a href="#/Untitled22">Chapter One</a></p>
<p class="toc1"><span href="#/Untitled23" title="Link target outside of Sample">Chapter Two</span></p>
<p class="toc1"><span href="#/Untitled24" title="Link target outside of Sample">Chapter Three</span></p>
<p class="toc1"><span href="#/Untitled25" title="Link target outside of Sample">Chapter Four</span></p>
<p class="toc1"><span href="#/Untitled26" title="Link target outside of Sample">Chapter Five</span></p>
<p class="toc2"><span href="#/Untitled27" title="Link target outside of Sample">A Biography of Joan Aiken</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Untitled21.vue?2b30e516